import { DisplayInputValue, EmptyRequiredFieldCount } from '@reapitform/dashboard-ui'
import React from 'react'
import { IAgentSettingsData } from '../../../../../api/agent-settings'
import { FlexContainer, TextSM } from '@reapit/elements'
import { agentContactDetailsValidationSchema } from '../edit-form'

const ContactDetailsDisplayView: React.FC<{ data?: null | IAgentSettingsData['contactDetails'] }> = ({ data }) => {
  if (!data) return
  return (
    <>
      <EmptyRequiredFieldCount validationSchema={agentContactDetailsValidationSchema} value={data} />
      <FlexContainer isFlexColumn>
        <DisplayInputValue title="Phone">{data.phone}</DisplayInputValue>
        <DisplayInputValue title="Facsimile">{data.facsimile}</DisplayInputValue>
        <DisplayInputValue title="Office Email">{data.email}</DisplayInputValue>
        <DisplayInputValue title="CC Email">
          <FlexContainer isFlexColumn>
            {data.emailCc.split(',').map((emailCc) => (
              <TextSM key={emailCc}>{emailCc}</TextSM>
            ))}
          </FlexContainer>
        </DisplayInputValue>
        <DisplayInputValue title="Address">{data.propertyAddressDisplay}</DisplayInputValue>
      </FlexContainer>
    </>
  )
}

export default ContactDetailsDisplayView
